import axios from "axios";

const API_URL = "/web/rest-fp/change-request";

export function changeAddressRequest(preparedData) {
  return axios.post(`${API_URL}/address`, preparedData);
}

export function changeCocRequest(preparedData) {
  return axios.post(`${API_URL}/coc`, preparedData);
}